import React, { useContext, useEffect, useState } from "react";

// Custom.
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import { VoAppContext } from "services/GlobalState";

export interface CallParams {
  action: string;
  // key?: string;
  // value?: any;
  [key: string]: any;
}

const Session: React.FC = () => {
  const [output, setOutput] = useState<any>(null);
  const { dispatch } = useContext(VoAppContext);

  // Methods.

  const makeCall = (params: CallParams) => {
    setOutput(params);
    window.top?.postMessage(params, "*");
  };

  const messageHandler = async (event: MessageEvent<any>) => {
    const { action } = event.data;
    switch (action) {
      case "getCurrentUser":
        makeCall({
          action: "getCurrentUser",
          key: "",
          value: {
            currentUser: VoAuth.currentUser,
            token: VoAuth.getToken(),
          },
        });
        break;
      case "logout":
        try {
          await VoAuth.logout();
          makeCall({
            action: "logout",
            value: true,
          });
        } catch (error) {
          makeCall({
            action: "logout",
            value: false,
          });
        }
        break;
      // case "checkAbility":
      //   makeCall({
      //     action: "checkAbility",
      //     ability: value,
      //     value: VoAuth.ability.can(value[0], value[1]),
      //     __seq,
      //   });
      //   break;
    }
  };

  // Effects.

  useEffect(() => {
    dispatch({
      key: "hideHeader",
      values: true,
    });
    window.addEventListener("message", messageHandler, false);
    makeCall({
      action: "sessionReady",
      key: "",
      value: true,
    });
    return () => window.removeEventListener("message", messageHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h4>SESSION</h4>
      <pre>{JSON.stringify(output)}</pre>
    </div>
  );
};

export default Session;
